export class AssocierRequestAuComite {
    requestId: string;
    rendezVousId: string;
    selected: boolean;
}